import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs/operators';

import { PageDto } from './../../shared/page.dto';
import { PageQueriesModel } from './../../shared/page-queries.model';
import { AccountingRuleFileDto } from './../accounting-rule-file.dto';

@Injectable()
export class AccountingRuleHistoryProcessingRestService {
  constructor(private http: HttpClient) {}

  list(queries: PageQueriesModel) {
    const url = this.apiUrlRuleHistoryFiles();
    const options = {
      params: queries.getParams()
    };

    return this.http.get<PageDto<AccountingRuleFileDto>>(url, options).pipe(
      map(d => {
        const page = new PageDto(d);
        page.content = d.content.map(i => new AccountingRuleFileDto(i));
        return page;
      })
    );
  }

  private apiUrlRuleHistoryFiles() {
    return `api/cspaccountingprocessing/accountingrulefiles/history`;
  }
}
